import { useEffect, useState } from "react";
import { NSLoading, NSRow } from 'namirasoft-site-react';
import { UserShortRow } from "namirasoft-account";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { AccountRouterProps } from "../AccountRouterProps";
import { AccountLayout } from "../AccountLayout";
import { useParams } from "react-router-dom";
import { AccountRoutes } from "../AccountRoutes";

interface UserViewDecidePageProps extends NSARouterMakerResult, AccountRouterProps
{ }

interface UserViewDecidePageState 
{
	user: UserShortRow | null;
}

export default function UserViewDecidePage(props: UserViewDecidePageProps) 
{
	let { id } = useParams();

	let [state, setState] = useState<UserViewDecidePageState>({ user: null });

	useEffect(() =>
	{
		if (id)
		{
			let this_user_id = props.account.token_manager.getUserData(x => x.id, "");
			if (this_user_id === id)
				props.url.redirect(AccountRoutes.UserProfile, {});
			else 
			{
				props.account.server.user.GetShort(id).then((user) =>
				{
					if (id)
						if (user.user_id === this_user_id)
							props.url.redirect(AccountRoutes.ServiceUserView(id), {});
						else
							props.url.redirect(AccountRoutes.UserView(id), {});
					setState(prev => { return { ...prev, user } });
				}).catch(() =>
				{
					setState(prev => { return { ...prev, user: null } });
				});
			}
		}
		// eslint-disable-next-line
	}, [id]);

	return (
		<AccountLayout {...props}
			action={{ title: 'Redirecting', description: '', menus: {} }}
		>
			<NSRow>
				{
					!state.user ? (
						<NSLoading />
					) : (<></>)
				}
			</NSRow>
		</AccountLayout >
	);
}